export var CardLockingStatusEnum;
(function (CardLockingStatusEnum) {
    CardLockingStatusEnum["LOCKED"] = "LOCKED";
    CardLockingStatusEnum["UNLOCKED"] = "UNLOCKED";
})(CardLockingStatusEnum || (CardLockingStatusEnum = {}));
//# sourceMappingURL=card-locking-status.enum.js.map